import { Sheet, Table } from '@mui/joy';

import { Variant } from 'theme/enums';

interface IProps {
  headerRow: string[];
  dataRows: string[][];
}

export const PreviewCsvTable = ({ headerRow, dataRows }: IProps) => (
  <Sheet
    variant={Variant.OUTLINED}
    sx={{
      borderRadius: 'sm',
      overflow: 'auto',
      flex: 1,
      minHeight: 0,
    }}
  >
    <Table
      size="sm"
      stickyHeader
      sx={{
        tableLayout: 'auto',
        width: 'auto',
        '& th, & td': {
          whiteSpace: 'nowrap',
          padding: '6px 10px',
          fontSize: '12px',
        },
        '& th': {
          fontWeight: 600,
          backgroundColor: 'background.level1',
        },
      }}
    >
      <thead>
        <tr>
          {headerRow.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataRows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td key={cellIndex}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  </Sheet>
);
